module.exports = __webpack_public_path__ + "static/media/upload.551cff06.svg";